import { useState, useEffect } from 'react';
import Section from '@/components/elements/Section';
import ListenButton from '@/components/elements/ListenButton';
import spotifyService from '@/services/SpotifyService';
import PodcastCard from '@/components/PodcastCard';
import PodcastCardSkeleton from '@/components/skeletons/PodcastCardSkeleton';
import { PODCAST } from '@/constants/constants';
import type { SpotifyEpisode } from '@/types/spotify.types';

interface PodcastEpisodesProps {
  background?: 'grey' | 'white';
}

function PodcastEpisodes({ background = 'grey' }: PodcastEpisodesProps) {
  const [loading, setLoading] = useState<boolean>(true);
  const [episodes, setEpisodes] = useState<SpotifyEpisode[]>([]);

  useEffect(() => {
    const fetchEpisodes = async () => {
      setLoading(true);
      try {
        const episodeLimit = 4;
        const response = await spotifyService.getPodcastEpisodes(PODCAST.spotifyId, episodeLimit);
        setEpisodes(response.items);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching podcast episodes:', error);
        setLoading(false);
        setEpisodes([]);
      }
    };

    fetchEpisodes();
  }, []);

  return (
    <Section
      id='podcast'
      background={background}
      title='eklipX Podcast: The Commodity Playbook'
      description='We interview traders, market experts and observers to provide a better understanding and navigate the latest commodity insights and trends.'
    >
      <div className='flex flex-col md:flex-row gap-4 mt-6'>
        <ListenButton variant='spotify' to={PODCAST.urls.spotify} />
        <ListenButton variant='youtube' to={PODCAST.urls.youtube} />
      </div>

      <div className='grid gap-4 md:grid-cols-2 mt-12'>
        {loading
          ? Array.from({ length: 4 }, (_, index) => <PodcastCardSkeleton key={index} background='grey' />)
          : episodes.map((episode) => (
              <PodcastCard key={episode.id} episode={episode} background={background === 'grey' ? 'white' : 'grey'} />
            ))}
      </div>
    </Section>
  );
}

export default PodcastEpisodes;
